import { useUserContext } from "@/contexts/UserContextProvider";
import { Button } from "../ui/button";

const StaleWarningBanner = () => {
  const { pastMidnight } = useUserContext();

  if (!pastMidnight) return null;

  return (
    <div className="h-12 bg-link text-black flex items-center text-xs justify-between">
      <p className="m-3">
        This page needs a refresh. Click the button on the right.
      </p>
      <Button
        className="mr-3 w-min"
        variant="paint"
        onClick={() => window.location.reload()}
      >
        Refresh
      </Button>
    </div>
  );
};

export default StaleWarningBanner;
